import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId, DocumentId } from '../../types/api/primaryKeys/PrimaryKey';
import { GroupDocumentBlob } from '../../types/api/documents/GroupDocumentBlob';

/**
 * 
 * @param packageId 
 * @param documentId 
 */
export async function getPackageDocument(packageId: EnrollmentPackageId, documentId: DocumentId) {
    const result = await ApiRequest.get<GroupDocumentBlob>(`packages/${packageId}/documents/${documentId}`);
    return result;
}